import { palette } from "@mui/system";

declare module "@mui/material/styles/createPalette" {
  interface SimplePaletteColorOptions {
    gradient?: string;
  }
}

export const pink = palette({
  color: {
    main: "#F328A5",
    gradient: "linear-gradient(99deg, #F328A5 -11.67%, #9322D0 120.63%)",
  },
});
